import * as ol from 'openlayers'

export default class BaseAspect extends ol.Feature {

  constructor(data) {
    super(data);
    this.setProperties(data);
    this.warningMessage = 'WARNING_MESSAGE';
    this.warningTitle = 'WARNING_MESSAGE_TITLE';
  }


  setProperties(data, type = 0) {
    this.set('id', data.id);
    this.set('referenceName', data.referenceName);
    this.set('rightClickSetting', data.rightClickSetting);

    if (data.hasOwnProperty('radius')) {
      this.set('radius', data.radius);
    } else {
      this.set('radius', 10);
    }

    if (data.hasOwnProperty('state')) {
      this.set('state', data.state);
    } else {
      this.set('state', -1);
    }
    this.set('linked', false);
    this.set('parentId', data.parentId);
    this.set('lastAction', '');
  }

  createFeature() {
    this.setStyle(this.createStyle());
    return this;
  }

  setZIndex(index = 1) {
    this.set('zIndex', index);
    this.origZIndex = index;
  }

  getZIndex() {
    return this.get('zIndex');
  }

  getOrigZIndex() {
    return this.origZIndex;
  }

  setBaseColor(color) {
    this.origColor = color;
  }

  getBaseColor(color) {
    return this.origColor;
  }

  setLastAction(action) {
    this.set('lastAction', action);
  }

  getLastAction() {
    return this.get('lastAction');
  }

  linkStatus() {
    return this.get('linked');
  }
  setLinkStatus(state, callback = null) {
    this.set('linked', true);
    if (callback != null) {
      callback();
    }
    return;
  }
  setUnlinkStatus(state) {
    return this.set('linked', false);
  }
  setLinkStatusIfNotLinked(callback = null) {
    //it does not wait and return immediately
    if (!this.get('linked')) {
      // window.socket.requestLink(this.get('id'), (status) => { this.setLinkStatus(status, callback) });
    } else if (callback != null) {
      callback();
    }
  }
  getImagePath(subPath, object, extension = null) {
    let ext = '.png';
    if (extension != null) {
      ext = extension;
    }
    let ret = null;
    try {
      ret = require('../assets/' + subPath + object + ext);
    } catch (e) {
      ret = -1
    }
    return ret;
  }
  leftClick() {
  }
  rightClick() {
  }
  getObject() {
    return this.N;
  }
  createTooltip(inclTimestamp = true) {
    let description = "";
    let id = "";
    let customerId = "";
    let name = "";
    let blinkState = "";
    let _id = this.getId();
    let _customer = this.get('customerName');
    let _name = this.get('name');
    let _info = this.get('info');
    let _description = this.get('description');
    let _state = this.get('state');
    let state = '';

    if (typeof _id != 'undefined' && _id !== null) {
      id = "<p class='pop-up-atribute' >id: " + _id + "</p>";
    }
    if (typeof _customer != 'undefined' && _customer !== null && _customer != "") {
      customerId = "<p class='pop-up-atribute' >customerName: " + _customer + "</p>";
    }

    if (_name != "NULL" && typeof _name != 'undefined' && _name !== null && _name != "") {
      name = "<p class='pop-up-atribute' >name: " + _name + "</p>";
    }

    blinkState = "";
    if (_info != "NULL" && typeof _info != 'undefined' && _info !== null && _info != "") {
      blinkState = "<p class='pop-up-atribute' >blinkState: " + _info + "</p>";
    }

    if (typeof _description != 'undefined' && _description !== null) {
      description = "<p class='pop-up-atribute' >description: " + _description + "</p>";
    }

    if (typeof _state != undefined && _state !== null) {
      state = "<p class='pop-up-atribute' >state: " + _state + "</p>";
    }

    let tooltipInfo = "<div id='map-popup-tooltip'>" +
      id +
      customerId +
      name +
      description +
      blinkState +
      state
    if (inclTimestamp) {
      tooltipInfo += "<p class='pop-up-atribute' >timestamp: " + this.timeConverter() + "</p>";
    }
    tooltipInfo += "</div>";
    return tooltipInfo;
  }
  timeConverter() {
    let a = new Date();
    let year = a.getFullYear();
    let month = a.getMonth() + 1;
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let sec = a.getSeconds();
    if (year < 10) {
      year = "0" + year.toString();
    } else {
      year = year.toString();
    }

    if (month < 10) {
      month = "0" + month.toString();
    } else {
      month = month.toString();
    }

    if (date < 10) {
      date = "0" + date.toString();
    } else {
      date = date.toString();
    }

    if (hour < 10) {
      hour = "0" + hour.toString();
    } else {
      hour = hour.toString();
    }

    if (min < 10) {
      min = "0" + min.toString();
    } else {
      min = min.toString();
    }

    if (sec < 10) {
      sec = "0" + sec.toString();
    } else {
      sec = sec.toString();
    }

    let time = date + '-' + month + '-' + year + ' ' + hour + ':' + min + ':' + sec;
    return time;
  }

  getLength(length, tooltipName) {
    if (tooltipName.length > length) {
      return tooltipName.length;
    } else {
      return length;
    }
  }

  objectDefinition() {
    return 'base class objectDefinition';
  }

  createStyle() {
    //should be overRided in extended classes
    //returns simple black dot
    return [
      new ol.style.Style({
        image: new ol.style.Circle({
          radius: 4,
          fill: new ol.style.Fill({
            color: '#F00'
          })
        })
      })
    ];
  }

  static _trasformPolylinecoordinates(origCoordinates) {
    let transformedCordinates = [];
    let coordinates = origCoordinates.trim().split(' ');

    //need to close the last point
    coordinates.push(coordinates[0]);
    coordinates.forEach(function(point) {
      let latLonPair = point.split(',');
      let pos = ol.proj.transform([parseFloat(latLonPair[1]), parseFloat(latLonPair[0])], 'EPSG:4326', 'EPSG:3857');
      transformedCordinates.push(pos);
    });

    return transformedCordinates;
  }

  trasformPolylinecoordinates(origCoordinates) {
    let transformedCordinates = [];
    let coordinates = origCoordinates.trim().split(' ');

    //need to close the last point
    // coordinates.push(coordinates[0]);
    coordinates.forEach(function(point) {
      let latLonPair = point.split(',');
      let pos = ol.proj.transform([parseFloat(latLonPair[0]), parseFloat(latLonPair[1])], 'EPSG:4326', 'EPSG:3857');
      transformedCordinates.push(pos);
    });

    return transformedCordinates;
  }

  showMouseOver() {
  }

  hideMouseOver() {
    // this.setStyle(this.createStyle());
  }

  static _createDeleteRequestObject(object) {
    return {
      childId: object.id,
      cleanDatabase: true
    };
  }
}
